import { render, staticRenderFns } from "./DetailedSales.vue?vue&type=template&id=7e0f665d"
import script from "./DetailedSales.vue?vue&type=script&lang=js"
export * from "./DetailedSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports